import { render } from "./RelatedItems.vue?vue&type=template&id=019dfb0d&scoped=true&ts=true"
import script from "./RelatedItems.vue?vue&type=script&lang=ts"
export * from "./RelatedItems.vue?vue&type=script&lang=ts"

import "./RelatedItems.vue?vue&type=style&index=0&id=019dfb0d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-019dfb0d"]])

export default __exports__